import { createStore } from "vuex";

import VuexPersist from 'vuex-persist';

const vuexLocalStorage = new VuexPersist({
  key: 'vuex', // The key to store the state on in the storage provider.
  storage: window.localStorage, // or window.sessionStorage or localForage
  // Function that passes the state and returns the state with only the objects you want to store.
  // reducer: state => state,
  // Function that passes a mutation and lets you decide if it should update the state in localStorage.
  // filter: mutation => (true)
});

export default createStore({
  state: {
    hideConfigButton: false,
    isPinned: true,
    showConfig: false,
    sidebarType: "bg-dark",
    isRTL: false,
    mcolor: "",
    darkMode: false,
    isNavFixed: false,
    isAbsolute: false,
    showNavs: true,
    showSidenav: true,
    showNavbar: true,
    showFooter: true,
    showMain: true,
    layout: "default",
    authUser: null,
    sound: 0,
    music: 0,
    lang: 'en',
  },
  getters: {
    user: (state) => {
      return state.authUser
    },
    language: (state) => {
      return state.lang;
    }
  },
  mutations: {
    setAuthUser: (state, payload) => {
      localStorage.setItem('auth', JSON.stringify(payload));
      state.authUser = payload;
    },
    setLanguage: (state, payload) => {
      localStorage.setItem('lang', JSON.stringify(payload));
      state.lang = payload;
    },
    removeAuthUser: (state) => {
      localStorage.setItem('auth', null);
      localStorage.setItem('authUserSettings', null);
      state.authUser = null;
      state.authUserSettings = null;
    },
    toggleConfigurator(state) {
      state.showConfig = !state.showConfig;
    },
    navbarMinimize(state) {
      const sidenav_show = document.querySelector(".g-sidenav-show");

      if (sidenav_show.classList.contains("g-sidenav-hidden")) {
        sidenav_show.classList.remove("g-sidenav-hidden");
        sidenav_show.classList.add("g-sidenav-pinned");
        state.isPinned = true;
      } else {
        sidenav_show.classList.add("g-sidenav-hidden");
        sidenav_show.classList.remove("g-sidenav-pinned");
        state.isPinned = false;
      }
    },
    sidebarType(state, payload) {
      state.sidebarType = payload;
    },
    navbarFixed(state) {
      state.isNavFixed = state.isNavFixed === false;
    },
    setSoundOrMusic: (state, payload) => {
      if (payload.type === 'sound') {
        localStorage.setItem('sound', payload.data);
        state.sound = payload.data
      } else {
        localStorage.setItem('music', payload.data);
        state.music = payload.data
      }
    },
  },
  actions: {
    saveAuthUser: (context, data) => {
      context.commit('setAuthUser', data);
    },
    saveLang: (context, data) => {
      context.commit('setLanguage', data);
    },
    saveAuthUserSettings: (context, data) => {
      context.commit('setAuthUserSettings', data);
    },
    removeAuthUser: (context) => {
      context.commit('removeAuthUser');
    },
    toggleSidebarColor({ commit }, payload) {
      commit("sidebarType", payload);
    },
    updateSoundOrMusic: (context, payload) => {
      context.commit('setSoundOrMusic', payload);
    }
  },
  plugins: [vuexLocalStorage.plugin]
});
